<div fxLayout="column" fxLayoutAlign="space-between">
  <div class="forge-typography--heading2 tt-margin--horiz">
    {{item.ProcessType}} - {{item.PacketNumber}}
  </div>

  <div class="tt-margin--left" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="forge-typography--subheading1" fxFlex="80">
      {{item.PacketDescription}} - {{item.CurrentStep}}
    </div>

    <forge-icon-button aria-label="View-Packet-UtilityBilling" (click)="openPacket()">
      <forge-tooltip placement="bottom">View packet</forge-tooltip>
      <forge-icon name="open_in_new"></forge-icon>
    </forge-icon-button>
  </div>

  <chartjs-container [config]="chartConfig" [heightPx]="50">
  </chartjs-container>

  <div class="tt-margin--horiz">
    @for (data of item.UniqueData; track data) {
      <div>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="uniqueData">
          <div class="forge-typography--label1">{{data.Label}}</div>
          <div class="forge-typography--body2">{{data.Value}}</div>
        </div>
      </div>
    }
  </div>
</div>
